/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import {
  DownloadPriceCardFilePayload
} from '@price-card/usecases/download-price-card/dowload-price-card.usecase';

export interface PriceCardFileState {
  priceCardFile: string;
  isFetching: boolean;
  error?: string;
}

const initialState: PriceCardFileState = {
  priceCardFile: '',
  isFetching: false,
};

export const priceCardFileSlice = createSlice({
  name: 'priceCardFile',
  initialState,
  reducers: {
    downloadPriceCardFile: (state, _action: PayloadAction<DownloadPriceCardFilePayload>) => {
      state.isFetching = true;
    },
    downloadPriceCardFileSuccess: (state) => {
      state.isFetching = false;
    },
    downloadPriceCardFileFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export const { downloadPriceCardFile, downloadPriceCardFileSuccess, downloadPriceCardFileFailure } =
  priceCardFileSlice.actions;

export default priceCardFileSlice.reducer;
